import React from 'react';

import { GenericSpan, GenericP, GenericDiv } from 'commonStyles';
import { SummaryIcons } from '../../../reporting/pages/summary/Styles';

import OutOfPolicyTag from './outOfPolicyTag';
import FlightInfoTooltip from './flightInfoTooltip';

import { LOB_TYPES, MRB_CONSTANTS } from 'AppConstants';
import { ICON_MAP } from '../../config';

const Location = ({ source, destination, subText = '', inPolicy = true, oopReasons = [], isReturnJourney = false, tripType, legs = [], type }) => {
	const showFlightTooltip = tripType === ICON_MAP[LOB_TYPES.FLIGHT] && Array.isArray(legs) && legs.length > 0;
	const showSubText = Boolean(subText);
	const fontWeight = type === MRB_CONSTANTS.UPCOMING_REQUEST_TYPE ? '400' : '900';

	return (
		<GenericDiv>
			<GenericP f_weight={fontWeight} fsize='14px' $lHeight='20px' color='#000'>
				{source}
				{destination && source && (
					<GenericSpan left_M='4' right_M='4' valign='middle'>
						<SummaryIcons icon={isReturnJourney ? 'returnArrow' : 'arw'} />
					</GenericSpan>
				)}
				{destination}
				{showFlightTooltip && <FlightInfoTooltip legs={legs} />}
			</GenericP>
			{showSubText ? (
				<GenericP fsize='12px' $lHeight='16px' color='#4A4A4A'>{subText}</GenericP>
			) : (!inPolicy && <OutOfPolicyTag reasons={oopReasons} />)}
		</GenericDiv>
	);
};

export default Location;
